import fetchData from "../services/fetchData";

const handleFetchUsers = async ({ page = "", limit = "", params }: any) => {
  const uri = `users/all/paginated?page=${page}&limit=${limit}&${params}`;
  const response = fetchData({ uri });
  return response;
};


export { handleFetchUsers };